import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import TFUNDashboard from './components/TFUNDashboard';
import TFUNCheckIn from './components/TFUNCheckIn';
import SimpleCheckIn from './components/SimpleCheckIn';
import GoogleAdsGeneratorPage from './components/GoogleAdsGeneratorPage';
import ErrorBoundary from './components/ErrorBoundary';
import BugReportFloatingButton from "./components/BugReportFloatingButton";
import { Toaster } from "./components/ui/toaster";

function App() {
    // Initialize variables outside try-catch to ensure proper scope
    let pathname, isCheckin, isSimpleCheckin, isGoogleAds, locationId;
    
    try {
        // Add debug logging
        console.log('🚀 App component is loading...');
        
        // Check if this is the checkin route
        pathname = window.location.pathname;
        isCheckin = pathname === '/checkin' || pathname === '/checkin/';
        isSimpleCheckin = pathname === '/simple-checkin' || pathname === '/simple-checkin/';
        isGoogleAds = pathname === '/google-ads' || pathname === '/google-ads/';
        const params = new URLSearchParams(window.location.search);
        locationId = params.get('location_id') || params.get('subaccount_id') || null;
        
        console.log('📍 Location details:', { 
            pathname, 
            isCheckin,
            isSimpleCheckin,
            isGoogleAds, 
            locationId,
            fullURL: window.location.href 
        });
    } catch (error) {
        console.error('❌ Error in App component initialization:', error);
        return React.createElement('div', { 
            style: { 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '18px',
                color: '#d32f2f',
                textAlign: 'center',
                padding: '20px'
            } 
        }, 
        React.createElement('h1', null, 'Critical Error'),
        React.createElement('p', null, 'The application failed to initialize.'),
        React.createElement('pre', { style: { fontSize: '12px', color: '#666' } }, error.toString())
        );
    }
    
    // Show error message if no location_id is provided
    if (!locationId) {
        console.log('⚠️ No locationId found, showing error message');
        return React.createElement('div', { 
            style: { 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '18px',
                color: '#333',
                textAlign: 'center',
                padding: '20px'
            } 
        }, 
        React.createElement('h1', { style: { color: '#d32f2f', marginBottom: '20px' } }, 'Studio Manager V5'),
        React.createElement('p', { style: { marginBottom: '10px' } }, 'Location ID is required to access the dashboard.'),
        React.createElement('p', { style: { color: '#666', fontSize: '14px' } }, 'Please access the dashboard with a valid location_id or subaccount_id parameter in the URL.'),
        React.createElement('p', { style: { color: '#999', fontSize: '12px', marginTop: '20px' } }, 'Current URL: ' + window.location.href)
        );
    }
    
    console.log('✅ LocationId found:', locationId, 'Route type:', { isCheckin, isSimpleCheckin, isGoogleAds });
    
    // Update document title and favicon
    useEffect(() => {
        if (isCheckin || isSimpleCheckin) {
            document.title = 'Check In - Studio Manager V5';
        } else if (isGoogleAds) {
            document.title = 'Google Ads Generator - Studio Manager V5';
        } else {
            document.title = 'Studio Manager V5 - Dashboard';
        }
    }, [isCheckin, isSimpleCheckin, isGoogleAds]);
    
    // New simple check-in page
    if (isSimpleCheckin) {
        console.log('🎯 Rendering SimpleCheckIn component');
        return (
            <>
                <SimpleCheckIn />
                <BugReportFloatingButton />
                <Toaster />
            </>
        );
    }
    
    if (isCheckin) {
        console.log('🎯 Rendering TFUNCheckIn component');
        return (
            <>
                <TFUNCheckIn locationId={locationId} />
                <BugReportFloatingButton />
                <Toaster />
            </>
        );
    }
    
    if (isGoogleAds) {
        console.log('🎯 Rendering GoogleAdsGeneratorPage component');
        return (
            <>
                <ErrorBoundary>
                    <GoogleAdsGeneratorPage locationId={locationId} />
                </ErrorBoundary>
                <BugReportFloatingButton />
                <Toaster />
            </>
        );
    }
    
    // Default dashboard
    console.log('🎯 Rendering TFUNDashboard component (default route)');
    return (
        <>
            {React.createElement(BrowserRouter, null, 
                React.createElement(Routes, null,
                    React.createElement(Route, { path: "*", element: React.createElement(TFUNDashboard, { locationId }) })
                )
            )}
            <BugReportFloatingButton />
            <Toaster />
        </>
    );
}

export default App;